/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { getComponentFromName } from '../../lib/utils';

import * as QuestionComponents from './index';

interface QuestionProps {
    question: Question | null;
    [key: string]: any;
}

const Question: React.FC<QuestionProps> = ({ question = null, ...props }) => {
    const { type = 'choices' } = question || {};
    // console.log('question', question);
    const QuestionComponent = getComponentFromName(QuestionComponents, type);
    return <QuestionComponent question={question} {...props} />;
};

export default Question;
